var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstantBonusIconFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 297,
    height: 239,
    viewBox: "0 0 297 239"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.635.341l60.707 64.574L234.728.341h-72.093zm-100.367 0l11.385 64.574L134.361.341H62.268zm28.94 64.797l49.793.003h7.498l57.29-.003-57.29-60.939-57.29 60.94zm145.467 0h59.594l-49.04-59.871-10.554 59.871zm-235.947 0h59.593L49.765 5.267.728 65.138zm237.82 13.057l-1.873.004-69.462 151.04L296.272 78.195h-57.725zm-163.621 0l73.572 160.464 73.57-160.464H74.926zm-74.199.004l129.055 151.04L60.32 78.199H.728z"
  })))));
}
SvgInstantBonusIconFill.displayName = 'InstantBonusIconFill';
export default SvgInstantBonusIconFill;